export const desnakify = (word) => {
  return word.replace(/_/g, ' ');
}


export const snakify = (word) => {
  return word.replace(/ /g, '_');
};
